import { render, staticRenderFns } from "./jiajialeServe.vue?vue&type=template&id=ad73bcfc&scoped=true&"
import script from "./jiajialeServe.vue?vue&type=script&lang=js&"
export * from "./jiajialeServe.vue?vue&type=script&lang=js&"
import style0 from "./jiajialeServe.vue?vue&type=style&index=0&id=ad73bcfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad73bcfc",
  null
  
)

export default component.exports